module.exports = __webpack_public_path__ + "img/gc_country_flag_th.3d18d8c3.svg";